export default "__VITE_ASSET__DT3ZY6fd__"